import { azureSttBackend } from "./azureSttBackend";
import type { SttBackend, SttBackendName } from "./types";
import { webSpeechSttBackend } from "./webSpeechSttBackend";

export type { SttBackend, SttBackendName, SttRecognitionOptions } from "./types";

let resolved: SttBackend | null = null;
let inflight: Promise<SttBackend | null> | null = null;

async function resolveBackend(): Promise<SttBackend | null> {
  if (await webSpeechSttBackend.isSupported()) return webSpeechSttBackend;
  if (await azureSttBackend.isSupported()) return azureSttBackend;
  return null;
}

export async function getSttBackend(): Promise<SttBackend> {
  if (resolved) return resolved;
  if (!inflight) {
    inflight = resolveBackend().then((backend) => {
      resolved = backend;
      return backend;
    });
  }
  const backend = await inflight;
  if (!backend) throw new Error("No STT backend available");
  return backend;
}

export async function isSttSupported(): Promise<boolean> {
  if (resolved) return true;
  if (!inflight) {
    inflight = resolveBackend().then((backend) => {
      resolved = backend;
      return backend;
    });
  }
  return (await inflight) !== null;
}

export function getResolvedBackendName(): SttBackendName | null {
  return resolved?.name ?? null;
}
